import { render, staticRenderFns } from "./FormPaquete.vue?vue&type=template&id=5fea65e8&"
import script from "./FormPaquete.vue?vue&type=script&lang=js&"
export * from "./FormPaquete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports